import React, { useEffect, useState } from "react";
import InputComponents from "../components/input";
import {
  addServiceDashboard,
  addStaffDashboard,
  completeProfileDashboard,
  getBusinessDashboard,
  getBusinessProfile,
  getBusinessServices,
} from "../logic/business/action";
import { useDispatch, useSelector } from "react-redux";
import {
  MdClose,
  MdDelete,
  MdCheckCircle,
  MdAdd,
  MdArrowForward,
  MdBusiness,
  MdPeople,
  MdSettings,
} from "react-icons/md";
import logo from "../images/logo_clock.png";
import { Link, useNavigate } from "react-router-dom";
import { logOut } from "../logic/login/action";
import FormikForm from "../components/commonForm";
import {
  feildsUpdateProfileWeb,
  initialValuesUpdateProfileWeb,
  validationSchemaUpdateProfileWeb,
} from "../fromsUtil/updateProfile";
import {
  feildsAddStaff,
  initialValuesAddStaff,
  validationSchemaAddStaff,
} from "../fromsUtil/addStaff";
import { motion, AnimatePresence } from "framer-motion";

const CompleteSetup = () => {
  const selector = useSelector((state) => state.business);
  const selectorAuth = useSelector((state) => state.auth);

  const dispatch = useDispatch();
  const [serviceDrop, setserviceDrop] = useState(false);

  const toggleserviceDropdown = () => {
    setserviceDrop((prev) => !prev);
  };
  const [staffDrop, setstaffDrop] = useState(false);

  const toggleStaffDropdown = () => {
    setstaffDrop((prev) => !prev);
  };

  const [profileDrop, setprofileDrop] = useState(false);

  const toggleProfileDropdown = () => {
    setprofileDrop((prev) => !prev);
  };

  useEffect(() => {
    getBusinessProfile(dispatch);

    getBusinessDashboard(dispatch);
  }, []);

  const nav = useNavigate();
  useEffect(() => {
    if (
      selector.dashboard?.isCompleted === true &&
      selector.dashboard?.totalService > 0 &&
      selector.dashboard?.totalStaff > 0
    ) {
      nav("/admin/qrCode");
    }
  }, [selector.dashboard]);

  const steps = [
    {
      id: 1,
      title: "Business Setup",
      description: "Update your profile information",
      icon: <MdBusiness className="text-2xl" />,
      isCompleted: selector.dashboard?.isCompleted,
      disabled: false,
      onClick: toggleProfileDropdown,
      btnText: "Complete Profile",
    },
    {
      id: 2,
      title: "Services",
      description: "Add services with charges",
      icon: <MdSettings className="text-2xl" />,
      isCompleted: selector.dashboard?.totalService > 0,
      disabled: !selector.dashboard?.isCompleted,
      onClick: toggleserviceDropdown,
      btnText: "Add Service",
    },
    {
      id: 3,
      title: "Staff",
      description: "Add staff details to generate your QR code",
      icon: <MdPeople className="text-2xl" />,
      isCompleted: selector.dashboard?.totalStaff > 0,
      disabled:
        !selector.dashboard?.isCompleted ||
        selector.dashboard?.totalService <= 0,
      onClick: toggleStaffDropdown,
      btnText: "Add Staff",
    },
  ];

  const completedSteps = steps.filter((step) => step.isCompleted).length;
  const progress = (completedSteps / steps.length) * 100;

  return (
    <div className="bg-gradient-to-br from-gray-50 to-gray-100 w-full min-h-screen flex flex-col items-center overflow-x-hidden">
      <AnimatePresence>
        {serviceDrop && <ServicePopup closePopup={toggleserviceDropdown} />}
        {staffDrop && <StaffPopup closePopup={toggleStaffDropdown} />}
        {profileDrop && <ProfilePopup closePopup={toggleProfileDropdown} />}
      </AnimatePresence>

      <header className="w-full lg:w-[90%] mx-auto flex items-center py-6 justify-between px-4 lg:px-8">
        <motion.img
          src={logo}
          className="w-20 h-20 drop-shadow-lg"
          alt="Logo"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
        />
        <div className="flex items-center gap-4">
          <p className="hidden lg:inline-block text-gray-600">
            (team@theappointmentapp.com)
          </p>
          <Link to={"/admin/login"} onClick={() => logOut(dispatch)}>
            <motion.p
              className="px-6 py-2 rounded-lg border-2 border-gray-300 hover:border-primary hover:bg-primary hover:text-white transition-all duration-300 cursor-pointer"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Login
            </motion.p>
          </Link>
        </div>
      </header>

      <div className="w-full lg:w-[90%] max-w-5xl mx-auto px-4 lg:px-8 py-8 flex-1">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="w-full bg-white shadow-2xl rounded-2xl p-6 lg:p-10 flex flex-col gap-6 overflow-x-hidden"
        >
          <div className="mb-4">
            <h1 className="font-bold text-3xl lg:text-4xl text-gray-800 mb-2">
              Complete your setup
            </h1>
            <p className="text-gray-600 text-lg">
              Let&apos;s finish your setup to get started with your business
            </p>

            {/* Progress Bar */}
            <div className="mt-6 mb-4">
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm text-gray-600">Progress</span>
                <span className="text-sm font-semibold text-primary">
                  {completedSteps} of {steps.length} completed
                </span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2.5">
                <motion.div
                  className="bg-gradient-to-r from-primary to-blue-400 h-2.5 rounded-full"
                  initial={{ width: 0 }}
                  animate={{ width: `${progress}%` }}
                  transition={{ duration: 0.8, ease: "easeOut" }}
                />
              </div>
            </div>
          </div>

          <div className="flex flex-col items-start pt-4 gap-6">
            {steps.map((step, index) => (
              <React.Fragment key={step.id}>
                <Setupcard
                  count={step.id}
                  disabled={step.disabled}
                  isCompleted={step.isCompleted}
                  onClick={step.onClick}
                  btnText={step.btnText}
                  title={step.title}
                  description={step.description}
                  icon={step.icon}
                  index={index}
                />
                {index < steps.length - 1 && (
                  <span
                    className={`h-12 ml-8 w-1 ${
                      !step.isCompleted ? "bg-gray-300" : "bg-primary"
                    } rounded-full transition-colors duration-300`}
                  />
                )}
              </React.Fragment>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  );
};

const ServicePopup = ({ closePopup }) => {
  const selector = useSelector((state) => state.business);
  const dispatch = useDispatch();
  const [services, setservices] = useState([
    {
      service: "",
      charges: "",
    },
  ]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submitService = async () => {
    if (services.length > 0) {
      let count = 0;
      for (let index = 0; index < services.length; index++) {
        const element = services[index];
        if (element.service === "" || element.charges === "") {
          count++;
        }
      }
      if (count > 0) {
        return;
      }
      setIsSubmitting(true);
      await addServiceDashboard(
        dispatch,
        services,
        selector.details?.business_id
      );
      setservices([
        {
          service: "",
          charges: "",
        },
      ]);
      setIsSubmitting(false);
      closePopup();
    }
  };

  // Close on ESC key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") {
        closePopup();
      }
    };
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [closePopup]);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="w-full h-screen left-0 top-0 fixed bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 overflow-y-auto p-4"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          closePopup();
        }
      }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.9, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.9, y: 20 }}
        transition={{ duration: 0.2 }}
        className="w-full max-w-2xl min-h-[50%] max-h-[90vh] p-6 lg:p-8 bg-white rounded-2xl relative shadow-2xl overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-6 pb-4 border-b">
          <h4 className="text-2xl font-bold text-gray-800">Add Services</h4>
          <button
            onClick={closePopup}
            className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
            aria-label="Close"
          >
            <MdClose className="text-2xl text-gray-600" />
          </button>
        </div>

        <div className="flex items-center justify-between mb-6">
          <p className="text-gray-600 text-sm">
            Add your services and their charges
          </p>
          <motion.button
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            onClick={() =>
              setservices((prev) => [
                ...prev,
                {
                  service: "",
                  charges: "",
                },
              ])
            }
            className="w-10 h-10 bg-primary hover:bg-primary/90 flex items-center justify-center text-white cursor-pointer rounded-full transition-colors shadow-md hover:shadow-lg"
          >
            <MdAdd className="text-xl font-semibold" />
          </motion.button>
        </div>

        <div className="w-full flex flex-col items-start gap-4 max-h-[50vh] overflow-y-auto pr-2 mb-6">
          {services.map((e, i) => (
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: i * 0.1 }}
              className="flex flex-col sm:flex-row items-start sm:items-center gap-3 w-full"
              key={i}
            >
              <div className="flex-1 w-full sm:w-auto">
                <InputComponents
                  isRequired={true}
                  message={"Services are required"}
                  value={e.service}
                  name={"service" + i}
                  onChange={(ev) => {
                    const temp = [...services];
                    temp[i].service = ev.target.value;
                    setservices(temp);
                  }}
                  label={"Service"}
                  placeholder="Enter service"
                />
              </div>
              <div className="w-full sm:w-32 flex-shrink-0">
                <InputComponents
                  isRequired={true}
                  type={"number"}
                  message={"Charges are required"}
                  value={e.charges}
                  name={"charges" + i}
                  onChange={(ev) => {
                    const temp = [...services];
                    temp[i].charges = ev.target.value;
                    setservices(temp);
                  }}
                  label={"Charges (₹)"}
                  placeholder="Amount"
                />
              </div>
              <button
                onClick={() => {
                  setservices((prev) =>
                    prev.length > 1 ? prev.filter((el, iv) => iv !== i) : prev
                  );
                }}
                disabled={services.length === 1}
                className="w-10 h-10 bg-red-500 hover:bg-red-600 disabled:bg-gray-300 disabled:cursor-not-allowed flex items-center justify-center text-white cursor-pointer rounded-full transition-colors shadow-md hover:shadow-lg flex-shrink-0"
              >
                <MdDelete className="text-lg" />
              </button>
            </motion.div>
          ))}
        </div>

        <div className="w-full flex items-center justify-center pt-4 border-t">
          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            className="button px-8 py-2.5 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
            onClick={submitService}
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              "Saving..."
            ) : (
              <>
                Save Services
                <MdArrowForward />
              </>
            )}
          </motion.button>
        </div>
      </motion.div>
    </motion.div>
  );
};

const StaffPopup = ({ closePopup }) => {
  const dispatch = useDispatch();
  const selector = useSelector((state) => state.business);
  const [selectedServices, setselectedServices] = useState([]);
  const [openservice, setopenservice] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    getBusinessServices(dispatch, selector.details?.business_id);
  }, [dispatch, selector.details?.business_id]);

  const submitService = async (values) => {
    setIsSubmitting(true);
    await addStaffDashboard(dispatch, {
      ...values,
      services: selectedServices.join(","),
    });
    setIsSubmitting(false);
    closePopup();
  };

  const openServiceDrop = () => {
    setopenservice((prev) => !prev);
  };

  // Close on ESC key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape" && !openservice) {
        closePopup();
      } else if (e.key === "Escape" && openservice) {
        setopenservice(false);
      }
    };
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [closePopup, openservice]);

  return (
    <>
      <AnimatePresence>
        {openservice && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="absolute z-30 w-full h-full bg-black/50 backdrop-blur-sm top-0 left-0 flex items-center justify-center p-4"
            onClick={(e) => {
              if (e.target === e.currentTarget) {
                setopenservice(false);
              }
            }}
          >
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
              className="w-full max-w-md p-6 lg:p-10 bg-white rounded-2xl relative shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="flex items-center justify-between mb-4 pb-4 border-b">
                <h4 className="text-xl font-bold">Select Services</h4>
                <button
                  onClick={() => setopenservice(false)}
                  className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100"
                >
                  <MdClose className="text-xl" />
                </button>
              </div>
              <div className="flex flex-col gap-2 w-full py-4 max-h-[400px] overflow-y-auto">
                <div className="w-full flex items-center justify-between p-3 rounded-lg hover:bg-gray-50 border border-gray-200">
                  <p className="font-semibold">All Services</p>
                  <input
                    checked={
                      selectedServices.length === selector.services?.length &&
                      selector.services?.length > 0
                    }
                    onChange={(ev) => {
                      if (Array.isArray(selector.services)) {
                        if (
                          selectedServices.length === selector.services?.length
                        ) {
                          setselectedServices([]);
                        } else {
                          setselectedServices(
                            selector.services?.map((e) => e.service_id)
                          );
                        }
                      } else {
                        setselectedServices([]);
                      }
                    }}
                    className="w-5 h-5 cursor-pointer"
                    type="checkbox"
                  />
                </div>
                {selector.services?.map((e, i) => (
                  <div
                    key={i}
                    className="w-full flex items-center justify-between p-3 rounded-lg hover:bg-gray-50 border border-gray-200"
                  >
                    <p>{e.service}</p>
                    <input
                      checked={selectedServices.includes(e.service_id)}
                      onChange={(ev) => {
                        if (selectedServices.includes(e.service_id)) {
                          setselectedServices((prev) =>
                            prev.filter((el) => el !== e.service_id)
                          );
                        } else {
                          setselectedServices((prev) => [
                            ...prev,
                            e.service_id,
                          ]);
                        }
                      }}
                      className="w-5 h-5 cursor-pointer"
                      type="checkbox"
                    />
                  </div>
                ))}
              </div>
              <button
                onClick={() => setopenservice(false)}
                className="button w-full mt-4"
              >
                Confirm Selection
              </button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="w-full z-20 h-screen left-0 top-0 fixed bg-black/50 backdrop-blur-sm flex items-center justify-center overflow-y-auto p-4"
        onClick={(e) => {
          if (e.target === e.currentTarget && !openservice) {
            closePopup();
          }
        }}
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.9, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.9, y: 20 }}
          className="w-full max-w-2xl min-h-[50%] p-6 lg:p-10 bg-white rounded-2xl relative shadow-2xl overflow-x-hidden"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex items-center justify-between mb-6 pb-4 border-b">
            <h4 className="text-2xl font-bold text-gray-800">Add Staff</h4>
            <button
              onClick={closePopup}
              className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
              aria-label="Close"
            >
              <MdClose className="text-2xl text-gray-600" />
            </button>
          </div>
          <div className="flex flex-col gap-4 items-center">
            <FormikForm
              initialValues={initialValuesAddStaff}
              fields={feildsAddStaff([
                {
                  value: "admin",
                  label: "Admin",
                  disabled: false,
                },
                {
                  value: "staff",
                  label: "Staff",
                  disabled: false,
                },
              ])}
              validationSchema={validationSchemaAddStaff}
              extra_element={
                <div
                  onClick={openServiceDrop}
                  className="cursor-pointer w-full"
                >
                  <InputComponents
                    disabled={true}
                    placeholder={`Selected services (${
                      selectedServices.length
                    }/${selector.services?.length || 0})`}
                  />
                </div>
              }
              action={(disabled) => (
                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  disabled={disabled || isSubmitting}
                  className="button w-full flex items-center justify-center gap-2 disabled:opacity-50"
                  type="submit"
                >
                  {isSubmitting ? (
                    "Adding Staff..."
                  ) : (
                    <>
                      Proceed
                      <MdArrowForward />
                    </>
                  )}
                </motion.button>
              )}
              onSubmit={submitService}
            />
          </div>
        </motion.div>
      </motion.div>
    </>
  );
};

const ProfilePopup = ({ closePopup }) => {
  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submitService = async (values) => {
    setIsSubmitting(true);
    await completeProfileDashboard(dispatch, values);
    setIsSubmitting(false);
    closePopup();
  };

  // Close on ESC key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") {
        closePopup();
      }
    };
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [closePopup]);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="w-full h-screen left-0 top-0 fixed bg-black/50 backdrop-blur-sm flex items-center justify-center overflow-y-auto p-4 z-50"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          closePopup();
        }
      }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.9, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.9, y: 20 }}
        transition={{ duration: 0.2 }}
        className="w-full max-w-2xl min-h-[50%] p-6 lg:p-10 bg-white rounded-2xl relative shadow-2xl overflow-x-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-6 pb-4 border-b">
          <h4 className="text-2xl font-bold text-gray-800">
            Complete your profile
          </h4>
          <button
            onClick={closePopup}
            className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
            aria-label="Close"
          >
            <MdClose className="text-2xl text-gray-600" />
          </button>
        </div>
        <div className="flex flex-col gap-4 items-center">
          <FormikForm
            initialValues={initialValuesUpdateProfileWeb}
            fields={feildsUpdateProfileWeb()}
            validationSchema={validationSchemaUpdateProfileWeb}
            action={(disabled) => (
              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                disabled={disabled || isSubmitting}
                className="button w-full flex items-center justify-center gap-2 disabled:opacity-50"
                type="submit"
              >
                {isSubmitting ? (
                  "Saving..."
                ) : (
                  <>
                    Complete Profile
                    <MdArrowForward />
                  </>
                )}
              </motion.button>
            )}
            onSubmit={submitService}
          />
        </div>
      </motion.div>
    </motion.div>
  );
};

const Setupcard = ({
  title,
  description,
  isCompleted,
  onClick,
  btnText,
  count,
  disabled,
  icon,
  index,
}) => {
  return (
    <motion.article
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: index * 0.1 }}
      className="flex items-center gap-4 w-full"
    >
      <figure
        className={`w-16 h-16 rounded-full border-2 transition-all duration-300 ${
          disabled
            ? "border-gray-300 bg-gray-100"
            : isCompleted
            ? "border-green-500 bg-green-500"
            : "border-primary bg-white"
        } flex items-center justify-center shadow-md`}
      >
        {isCompleted ? (
          <MdCheckCircle className="text-white text-3xl" />
        ) : (
          <span
            className={`font-bold text-2xl ${
              disabled ? "text-gray-400" : "text-primary"
            }`}
          >
            {count}
          </span>
        )}
      </figure>
      <section className="flex-1 flex flex-col gap-2">
        <section className="flex w-full gap-3 items-center">
          <div className="flex items-center gap-3">
            {icon && (
              <div
                className={`p-2 rounded-lg ${
                  isCompleted
                    ? "bg-green-100 text-green-600"
                    : disabled
                    ? "bg-gray-100 text-gray-400"
                    : "bg-blue-100 text-primary"
                }`}
              >
                {icon}
              </div>
            )}
            <h4 className="font-bold text-xl text-gray-800">{title}</h4>
          </div>
          {isCompleted && (
            <motion.span
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              className="px-3 py-1 bg-green-100 text-green-700 rounded-full text-xs font-semibold"
            >
              Completed
            </motion.span>
          )}
        </section>
        <p className="font-normal text-sm text-gray-600 ml-0">{description}</p>
        {!isCompleted && (
          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            className="button w-48 text-sm !p-2.5 mt-2 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            disabled={disabled}
            onClick={onClick}
          >
            {btnText}
            <MdArrowForward className="text-lg" />
          </motion.button>
        )}
      </section>
    </motion.article>
  );
};

export default CompleteSetup;
